import { render, staticRenderFns } from "./BizTeamMoney.vue?vue&type=template&id=45bd8dfb&scoped=true"
import script from "./BizTeamMoney.vue?vue&type=script&lang=js"
export * from "./BizTeamMoney.vue?vue&type=script&lang=js"
import style0 from "./BizTeamMoney.vue?vue&type=style&index=0&id=45bd8dfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd8dfb",
  null
  
)

export default component.exports